// extracted by mini-css-extract-plugin
module.exports = {"heading":"Home_heading__3Mn4y","section":"Home_section__1uiwC","sectionHeading":"Home_sectionHeading__1rzQV","sincerely":"Home_sincerely__1Yqrh"};